import { useSearchParams } from 'react-router-dom';
import InscriptionPage from '../InscriptionPage/InscriptionPage';

function CalendlyInscriptionPage() {
  const [searchParams] = useSearchParams();

  return (
    <InscriptionPage
      initialEmail={searchParams.get('email') || ''}
      initialUserDataId={searchParams.get('userDataId') || searchParams.get('id') || ''}
      initialCareerId={searchParams.get('careerId') || ''}
      initialPhone={searchParams.get('phone') || searchParams.get('movil') || ''}
    />
  );
}

export default CalendlyInscriptionPage;
